<script>
  import { KeypadMenu } from "@saztrek/firefly";
  import { navigateTo } from "svelte-router-spa";
  import { currentUser } from "../../../stores/current_user";

  const roleTypeForNEMO = $currentUser.roles.find(
    (role) => role.appCode === "nemo"
  ).isAdmin;

  let items = [
    {
      label: "Sheets",
      action: () => navigateTo("/nemo/sheets"),
      app: "nemo"
    },
    {
      label: "Compliance",
      action: () => navigateTo("/nemo/compliance"),
      app: "nemo"
    },
    {
      label: "Reports",
      action: () => navigateTo("/nemo/reports"),
      app: "nemo"
    }
  ];

  if (roleTypeForNEMO === "admin") {
    items = [
      ...items,
      {
        label: "Setup",
        action: () => navigateTo("/nemo/sheetcontexts"),
        app: "nemo"
      }
    ];
  }
</script>

<div class="flex justify-center pt-20">
  <KeypadMenu {items} size="l" />
</div>
